export default function groupByStartEndTime(arr) {
  return [...arr.reduce((r, o) => {
    const key = o.opening_time + '-' + o.closing_time;

    const item = r.get(key) || Object.assign({}, o, {
      days: [],
    });
    if (o.day) {
      item.days.push(o.day);
    }

    return r.set(key, item);
  }, new Map()).values()];
}
